import axios from '@fs/zion-axios'
import { useQuery } from 'react-query'
import { useEffectiveUser } from '@fs/zion-user'

import toSafeError from '../utils/toSafeError'

export default function useUserSegment() {
  const { cisId } = useEffectiveUser()
  const response = useQuery({
    queryKey: ['userSegment', { cisId }],
    queryFn: () => getUserSegment(cisId),
    // about 20 components read the segment and mount at different times; without this each one refetches it
    staleTime: 5 * 60 * 1000,
  })
  return response
}

async function getUserSegment(userCisId) {
  if (!userCisId) {
    return undefined
  }
  return axios
    .get(`/service/home/pb/users/${userCisId}/segment?includeAncestorCountries=true`)
    .then(({ data }) => {
      const userData = { ...data, ancestry: data.ancestralCountries }
      delete userData.ancestralCountries
      return userData
    })
    .catch((error) => {
      // react-query logs a failed query's error to the console, so hand it one without the request config
      throw toSafeError(error)
    })
}
